import { RootState } from 'store/rootReducer';
import { selectorsFactory } from '../utils';

export const adminOrganizationSpecialHostRolesSlice = (state: RootState) => state.entities.adminSpecialHostRoles;

export const adminOrganizationSpecialHostRolesState = selectorsFactory.createStaticKeyWindowStateMemoizedSelector(
  adminOrganizationSpecialHostRolesSlice,
);
